<section class="mainContainer">
  <div class="allQuizData dataContainer">
    <div>
      <h1>Données de toutes les bornes</h1>
    </div>

    <div class="multiStatContainer">
      <div class="monoStatContainer">
        <h3>Nombre de CV</h3>
        <p>{{cvNumberAll}}</p>
      </div>
      <div class="monoStatContainer">
        <h3>Impression de CV</h3>
        <p>{{cvPrintAll}}</p>
      </div>
      <div class="monoStatContainer">
        <h3>Envoi de CV par mail</h3>
        <p>{{cvEmailAll}}</p>
      </div>
    </div>
  </div>
  <div class="currentQuizData dataContainer">
    <div>
      <h1>Données borne actuelle</h1>
    </div>

    <div class="multiStatContainer">
      <div class="monoStatContainer">
        <h3>Nombre de CV</h3>
        <p>{{cvNumber}}</p>
      </div>
      <div class="monoStatContainer">
        <h3>Impression de CV</h3>
        <p>{{cvPrint}}</p>
      </div>
      <div class="monoStatContainer">
        <h3>Envoi de CV par mail</h3>
        <p>{{cvEmail}}</p>
      </div>
    </div>
  </div>
  <div>
    <button id="btnAddQuestion" mat-raised-button color="accent" (click)="exportAllData()">
      <mat-icon>save_alt</mat-icon>{{'exportAllData' | translation}}
    </button>
  </div>
</section>
